module.exports = "pegasus/assets/blocks/column-9-theme5.png";